module.exports = __webpack_public_path__ + "4ac4546521734f79bedc866dbe3b950b.pdf";